module.exports = __webpack_public_path__ + "static/img/bg_two.9ed18c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diagnosis/bg_two.png
// module id = fJTT
// module chunks = 3